<template>
    <v-container fluid class="text-block">
        <h1 class="underline">Alter Ehemann</h1>
        <p class="subtitle">Music: Lemo, Lyrics: Rafael</p>
        <div>
            <p>
                Hallo hallo, hier spricht dein alter Ehemann<br>
                Ich wollt mich nur mal melden<br>
                Erählen wie’s mir geht<br>
                Ich bin schon jahrelang ein Teil von dir oh ja<br>
                Du bist mir richtig vertraut
            </p>
            <p>
                Hallo hallo, sag erinnerst du dich dran<br>
                Frisch aus der Uni in die Schule gehen<br>
                Noch grün hinter den Ohren<br>
                Du hast sie jahrelang begleitet<br>
                Selbst wenn einer mal den andern verhaut
            </p>
            <p class="underline subtitle mb-0">BRIDGE</p>
            <p>
                In der Schule bist du spitze<br>
                Gehörst zu den besten<br>
                Egal ob in der Lesenacht, oder Sommerfesten<br>
                Für viele schon ein Vorbild<br>
                Doch für mich einfach 'ne perfekte Frau
            </p>
            <div class="chorus">
            <p class="underline subtitle mb-0">CHORUS</p>
            <p>
                Ich find dich immer noch<br>
                Atemberaubend<br>
                Wie Mona Lisa mit nem Lächeln<br>
                Ein Kunstwerk deine Pinselstriche<br>
                Hey, ich seh’ mir Bilder an<br>
                Oh, was haben wir getan<br>
                Wir waren dort - und da<br>
                Und trotzdem nie allein<br>
                Ob Sonne oder Mondschein<br>
                Schöner kann’s nicht sein, denn du<br>
                Bist mein Tanzpartner fürs Leben<br>
            </p>
            </div>
            <p>
                Hallo hallo, sag kannst du dich noch erinnern<br>
                Haben nächtens durchgeschlafen<br>
                Wurden nicht ständig geweck und<br>
                haben uns dann noch im Morgengrauen<br>
                einfach noch zur Seite gedreht
            </p>
            <p>
                Hallo hallo, ist das wirklich schon vorbei<br>
                Gemütlich still und leise Bücher lesen<br>
                Das kann es doch nicht sein<br>
                Es ist generell so laut geworden<br>
                Aber sind’s nicht süß uns’re Zwei
            </p>
            <p class="underline subtitle mb-0">BRIDGE</p>
            <p>
                Sie werden groß und immer größer<br>
                Ja, gehören zu den besten<br>
                Benedikt und kleine Marlies, sind sie nicht zum fressen<br>
                Der Papa ganz ok<br>
                Doch die Mama eine perfekte Frau, Frau
            </p>
            <div class="chorus">
                <p class="underline subtitle mb-0">CHORUS</p>
                <p>
                    Ich find dich immer noch<br>
                    Atemberaubend<br>
                    Wie Mona Lisa mit nem Lächeln<br>
                    Ein Kunstwerk deine Pinselstriche<br>
                    Hey, ich seh’ mir Bilder an<br>
                    Oh, was haben wir getan<br>
                    Wir waren dort - und da<br>
                    Und trotzdem nie allein<br>
                    Ob Sonne oder Mondschein<br>
                    Schöner kann’s nicht sein, denn du<br>
                    Bist mein Tanzpartner fürs Leben<br>
                </p>
            </div>
            <p>
                Ist das wirklich schon vorbei?<br>
                Sag was wird jetzt aus uns zweien?<br>
                Das ist noch lange nicht vorbei, nein<br>
                Komm und tanz<br>
                Komm und tanz<br>
                Mein Lebenspartner<br>
            </p>
            <div class="chorus">
                <p class="underline subtitle mb-0">CHORUS</p>
                <p>
                    Ich find dich immer noch<br>
                    Immer noch, Atemberaubend<br>
                    Wie Mona Lisa mit nem Lächeln<br>
                    Ein Kunstwerk deine Pinselstriche<br>
                    Hey, ich seh’ mir Bilder an<br>
                    Oh, was haben wir getan<br>
                    Wir waren dort - und da<br>
                    Und trotzdem nie allein<br>
                    Ob Sonne oder Mondschein --<br>
                    Oh, ich find dich immer noch<br>
                    Atemberaubend<br>
                    Wie Mona Lisa mit nem Lächeln<br>
                    Ein Kunstwerk deine Pinselstriche<br>
                </p>
            </div>
            <p>
                Hallo hallo, hier spricht dein alter Ehemann<br>
                Ich wollt mich nur mal melden<br>
                Erählen wie’s mir geht<br>
                Ich bin schon jahrelang ein Teil von dir oh ja<br>
                Du bist mir richtig vertraut
            </p>
        </div>
    </v-container>
</template>

<script>
    import '../assets/main.css';
    export default {
        name: "Lyrics"
    }
</script>

<style scoped>

    .chorus {
        margin-left: -10px;
        padding-left: 8px;
        border-left: solid rgba(255, 205, 0, .8) 2px;
    }
</style>
